import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
    ContentWrapper,
    HeaderContainer,
    Title,
    ProfilePageContainer,
    TemplateList,
} from "./TemplatesPage.styles";
import Sidebar from "../../components/Sidebar";
import { fetchDocumentTemplates } from "../../services/documentService/documentService";
import { DocumentTemplate } from "../../services/documentService/documentService.types";
import DocumentCard from "../../components/DocumentCard/DocumentCard";

import { useNotify } from "context/NotificationContext";
const TemplatesPage: React.FC = () => {
    const [templates, setTemplates] = useState<DocumentTemplate[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const toast = useNotify();
    const navigate = useNavigate();

    useEffect(() => {
        const loadTemplates = async () => {
            try {
                setLoading(true);
                const fetchedTemplates = await fetchDocumentTemplates();
                const sortedTemplates = fetchedTemplates.sort((a, b) => {
                    return Number(b.is_subscribed) - Number(a.is_subscribed);
                });
                setTemplates(sortedTemplates);
            } catch (err) {
                setError("Ошибка при загрузке шаблонов");
            } finally {
                setLoading(false);
            }
        };

        loadTemplates();
    }, []);

    const handleCardClick = (template: DocumentTemplate) => {
        navigate(`/documents/${template.id}/versions?templateName=${template.title}`); 
        // if (template.is_subscribed) {
        //     navigate(`/documents/${template.id}/versions?templateName=${template.title}`); 
        // } else {
        //     toast.show({
        //         severity: "warn",
        //         summary: "Не доступен",
        //         detail: "Этот документ доступен по другой подписке",
        //         life: 3000,
        //     });
        // }
    };

    return (
        <ProfilePageContainer>
            <Sidebar />
            <ContentWrapper>
                <HeaderContainer>
                    <Title>Шаблоны документов</Title>
                </HeaderContainer>
                {loading && <p>Загрузка...</p>}
                {error && <p>{error}</p>}
                {!loading && !error && (
                    <TemplateList>
                        {templates.map((template) => (
                            <DocumentCard
                                key={template.id}
                                title={template.title}
                                templateId={template.id}
                                isSubscribed={template.is_subscribed}
                                onClick={() => handleCardClick(template)}
                            />
                        ))}
                    </TemplateList>
                )}
            </ContentWrapper>
        </ProfilePageContainer>
    );
};

export default TemplatesPage;
